export const READERS_CLUB = '/readers-club'
